export const GET_EMPLOYEE_STARTED = 'GET_EMPLOYEE_STARTED';
export const GET_EMPLOYEE_SUCCESS = 'GET_EMPLOYEE_SUCCESS';
export const GET_EMPLOYEE_FAILED = 'GET_EMPLOYEE_FAILED';
export const EMPLOYEE_SKILLS_UPDATED = 'EMPLOYEE_SKILLS_UPDATED';
export const EMPLOYEE_WORK_HISTORY_UPDATED = 'EMPLOYEE_WORK_HISTORY_UPDATED';
export const EMPLOYEE_EDUCATION_UPDATED = 'EMPLOYEE_EDUCATION_UPDATED';
export const EMPLOYEE_LOCATIONS_INTERESTED_UPDATED =
  'EMPLOYEE_LOCATIONS_INTERESTED_UPDATED';
export const EMPLOYEE_OPEN_TO_WORK_UPDATED = 'EMPLOYEE_OPEN_TO_WORK_UPDATED';
export const EMPLOYEE_OPEN_TO_WORK_REMOTE_UPDATED =
  'EMPLOYEE_OPEN_TO_WORK_REMOTE_UPDATED';
export const EMPLOYEE_INTERESTED_ROLES_UPDATED =
  'EMPLOYEE_INTERESTED_ROLES_UPDATED';
export const EMPLOYEE_COMPETENCIES_UPDATED = 'EMPLOYEE_COMPETENCIES_UPDATED';
export const EMPLOYEE_GET_PROFILE_IMAGE_STARTED =
  'EMPLOYEE_GET_PROFILE_IMAGE_STARTED';
export const EMPLOYEE_GET_PROFILE_IMAGE_SUCCESS =
  'EMPLOYEE_GET_PROFILE_IMAGE_SUCCESS';
export const EMPLOYEE_GET_PROFILE_IMAGE_FAILED =
  'EMPLOYEE_GET_PROFILE_IMAGE_FAILED';
export const GET_RECOMMENDED_VIDEO_STARTED = 'GET_RECOMMENDED_VIDEO_STARTED';
export const GET_RECOMMENDED_VIDEO_SUCCESS = 'GET_RECOMMENDED_VIDEO_SUCCESS';
export const GET_RECOMMENDED_VIDEO_FAILED = 'GET_RECOMMENDED_VIDEO_FAILED';
export const GET_ANALIZED_RESUME = 'GET_ANALIZED_RESUME';
export const OPEN_RESUME_MODAL = 'OPEN_RESUME_MODAL';
export const CLOSE_RESUME_MODAL = 'CLOSE_RESUME_MODAL';
export const CHANGE_RESUME_MODAL_STEP = 'NEXT_RESUME_MODAL_STEP';
export const GET_ANALIZED_RESUME_STARTED = 'GET_ANALIZED_RESUME_STARTED';
export const GET_ANALIZED_RESUME_PARTIALLY_SUCCESS =
  'GET_ANALIZED_RESUME_PARTIALLY_SUCCESS';
export const GET_UNNORMSKILLS_RESUME_PARTIALLY_SUCCESS =
  'GET_UNNORMSKILLS_RESUME_PARTIALLY_SUCCESS';
export const GET_ANALIZED_RESUME_SUCCESS = 'GET_ANALIZED_RESUME_SUCCESS';
export const SELECT_RESUME_SECTIONS = 'SELECT_RESUME_SECTIONS';
export const GET_ANALIZED_RESUME_FAILED = 'GET_ANALIZED_RESUME_FAILED';
export const SAVE_RESUME_DATA_FAILED = 'SAVE_RESUME_DATA_FAILED';
export const GET_SUGGESTED_SKILLS_STARTED = 'GET_SUGGESTED_SKILLS_STARTED';
export const GET_SUGGESTED_SKILLS_SUCCESS = 'GET_SUGGESTED_SKILLS_SUCCESS';
export const GET_SUGGESTED_SKILLS_FAILED = 'GET_SUGGESTED_SKILLS_FAILED';
export const GET_SUGGESTED_COMPETENCIES_STARTED =
  'GET_SUGGESTED_COMPETENCIES_STARTED';
export const GET_SUGGESTED_COMPETENCIES_SUCCESS =
  'GET_SUGGESTED_COMPETENCIES_SUCCESS';
export const GET_SUGGESTED_COMPETENCIES_FAILED =
  'GET_SUGGESTED_COMPETENCIES_FAILED';
export const SAVE_SELECTED_SKILLS_STARTED = 'SAVE_SELECTED_SKILLS_STARTED';
export const SAVE_SELECTED_SKILLS_SUCCESS = 'SAVE_SELECTED_SKILLS_SUCCESS';
export const SAVE_SELECTED_SKILLS_FAILED = 'SAVE_SELECTED_SKILLS_FAILED';
export const SEARCH_SKILLS_STARTED = 'SEARCH_SKILLS_STARTED';
export const SEARCH_SKILLS_SUCCESS = 'SEARCH_SKILLS_SUCCESS';
export const SEARCH_SKILLS_FAILED = 'SEARCH_SKILLS_FAILED';
export const OPEN_CAREER_MODAL = 'OPEN_CAREER_MODAL';
export const CLOSE_CAREER_MODAL = 'CLOSE_CAREER_MODAL';
export const SAVE_OPEN_TO_WORK_STARTED = 'SAVE_OPEN_TO_WORK_STARTED';
export const SAVE_OPEN_TO_WORK_SUCCESS = 'SAVE_OPEN_TO_WORK_SUCCESS';
export const SAVE_OPEN_TO_WORK_FAILED = 'SAVE_OPEN_TO_WORK_FAILELD';
export const SAVE_OPEN_TO_WORK = 'SAVE_OPEN_TO_WORK';
export const SAVE_OPEN_TO_WORK_REMOTE_STARTED =
  'SAVE_OPEN_TO_WORK_REMOTE_STARTED';
export const SAVE_OPEN_TO_WORK_REMOTE_SUCCESS =
  'SAVE_OPEN_TO_WORK_REMOTE_SUCCESS';
export const SAVE_OPEN_TO_WORK_REMOTE_FAILED =
  'SAVE_OPEN_TO_WORK_REMOTE_FAILELD';
export const SAVE_LOCATIONS_INTERESTED_STARTED =
  'SAVE_LOCATIONS_INTERESTED_STARTED';
export const SAVE_LOCATIONS_INTERESTED_SUCCESS =
  'SAVE_LOCATIONS_INTERESTED_SUCCESS';
export const SAVE_LOCATIONS_INTERESTED_FAILED =
  'SAVE_LOCATIONS_INTERESTED_FAILELD';
export const GET_LOCATIONS_STARTED = 'GET_LOCATIONS_STARTED';
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS';
export const GET_LOCATIONS_FAILED = 'GET_LOCATIONS_FAILED';
export const SAVE_WORK_HISTORY_STARTED = 'SAVE_WORK_HISTORY_STARTED';
export const SAVE_WORK_HISTORY_SUCCESS = 'SAVE_WORK_HISTORY_SUCCESS';
export const SAVE_WORK_HISTORY_FAILED = 'SAVE_WORK_HISTORY_FAILED';
export const SAVE_EDUCATION_STARTED = 'SAVE_EDUCATION_STARTED';
export const SAVE_EDUCATION_SUCCESS = 'SAVE_EDUCATION_SUCCESS';
export const SAVE_EDUCATION_FAILED = 'SAVE_EDUCATION_FAILED';
export const UPDATE_WORK_HISTORY_STARTED = 'UPDATE_WORK_HISTORY_STARTED';
export const UPDATE_WORK_HISTORY_SUCCESS = 'UPDATE_WORK_HISTORY_SUCCESS';
export const UPDATE_WORK_HISTORY_FAILED = 'UPDATE_WORK_HISTORY_FAILED';
export const REMOVE_WORK_HISTORY_STARTED = 'REMOVE_WORK_HISTORY_STARTED';
export const REMOVE_WORK_HISTORY_SUCCESS = 'REMOVE_WORK_HISTORY_SUCCESS';
export const REMOVE_WORK_HISTORY_FAILED = 'REMOVE_WORK_HISTORY_FAILED';
export const OPEN_WORK_HISTORY_MODAL = 'OPEN_WORK_HISTORY_MODAL';
export const CLOSE_WORK_HISTORY_MODAL = 'CLOSE_WORK_HISTORY_MODAL';
export const UPDATE_EDUCATION_STARTED = 'UPDATE_EDUCATION_STARTED';
export const UPDATE_EDUCATION_SUCCESS = 'UPDATE_EDUCATION_SUCCESS';
export const UPDATE_EDUCATION_FAILED = 'UPDATE_EDUCATION_FAILED';
export const REMOVE_EDUCATION_STARTED = 'REMOVE_EDUCATION_STARTED';
export const REMOVE_EDUCATION_SUCCESS = 'REMOVE_EDUCATION_SUCCESS';
export const REMOVE_EDUCATION_FAILED = 'REMOVE_EDUCATION_FAILED';
export const OPEN_EDUCATION_MODAL = 'OPEN_EDUCATION_MODAL';
export const CLOSE_EDUCATION_MODAL = 'CLOSE_EDUCATION_MODAL';
export const UPDATE_INTERESTED_ROLES_STARTED =
  'UPDATE_INTERESTED_ROLES_STARTED';
export const UPDATE_INTERESTED_ROLES_SUCCESS =
  'UPDATE_INTERESTED_ROLES_SUCCESS';
export const UPDATE_INTERESTED_ROLES_FAILED = 'UPDATE_INTERESTED_ROLES_FAILED';

export const GET_PROFILE_COMPLETENESS_STARTED =
  'GET_PROFILE_COMPLETENESS_STARTED';
export const GET_PROFILE_COMPLETENESS_FAILED =
  'GET_PROFILE_COMPLETENESS_FAILED';
export const GET_PROFILE_COMPLETENESS_SUCCESS =
  'GET_PROFILE_COMPLETENESS_SUCCESS';

export const UPDATE_PROFILE_COMPLETENESS_STARTED =
  'UPDATE_PROFILE_COMPLETENESS_STARTED';
export const UPDATE_PROFILE_COMPLETENESS_SUCCESS =
  'UPDATE_PROFILE_COMPLETENESS_SUCCESS';
export const UPDATE_PROFILE_COMPLETENESS_FAILED =
  'UPDATE_PROFILE_COMPLETENESS_FAILED';
export const EMPLOYEE_PROFILE_COMPLETENESS_UPDATED =
  'EMPLOYEE_PROFILE_COMPLETENESS_UPDATED';
export const EMPLOYEE_RESUME_UPDATED = 'EMPLOYEE_RESUME_UPDATED';
export const GET_SUCCESS_PROFILE_TOP_CATEGORIES_STARTED =
  'GET_SUCCESS_PROFILE_TOP_CATEGORIES_STARTED';
export const GET_SUCCESS_PROFILE_TOP_CATEGORIES_SUCCESS =
  'GET_SUCCESS_PROFILE_TOP_CATEGORIES_SUCCESS';
export const GET_SUCCESS_PROFILE_TOP_CATEGORIES_FAILED =
  'GET_SUCCESS_PROFILE_TOP_CATEGORIES_FAILED';
export const GET_SUCCESS_PROFILE_STARTED = 'GET_SUCCESS_PROFILE_STARTED';
export const GET_SUCCESS_PROFILE_SUCCESS = 'GET_SUCCESS_PROFILE_SUCCESS';
export const GET_SUCCESS_PROFILE_FAILED = 'GET_SUCCESS_PROFILE_FAILED';
export const EMPLOYEE_FOCUS_SKILLS_UPDATED = 'EMPLOYEE_FOCUS_SKILLS_UPDATED';
export const SAVE_SELECTED_FOCUS_SKILLS_STARTED =
  'SAVE_SELECTED_FOCUS_SKILLS_STARTED';
export const SAVE_SELECTED_FOCUS_SKILLS_SUCCESS =
  'SAVE_SELECTED_FOCUS_SKILLS_SUCCESS';
export const SAVE_SELECTED_FOCUS_SKILLS_FAILED =
  'SAVE_SELECTED_FOCUS_SKILLS_FAILED';
export const MARK_FIELD_AS_READ_STARTED = 'MARKED_FIELD_AS_READ_STARTED';
export const MARK_FIELD_AS_READ_SUCCESS = 'MARKED_FIELD_AS_READ_SUCCESS';
export const MARK_FIELD_AS_READ_FAILED = 'MARKED_FIELD_AS_READ_FAILED';
export const GET_MARKED_FIELDS_AS_READ_STARTED =
  'GET_MARKED_FIELDS_AS_READ_STARTED';
export const GET_MARKED_FIELDS_AS_READ_SUCCESS =
  'GET_MARKED_FIELDS_AS_READ_SUCCESS';
export const GET_MARKED_FIELDS_AS_READ_FAILED =
  'GET_MARKED_FIELDS_AS_READ_FAILED';
export const SAVE_SELECTED_COMPETENCIES_STARTED =
  'SAVE_SELECTED_COMPETENCIES_STARTED';
export const SAVE_SELECTED_COMPETENCIES_SUCCESS =
  'SAVE_SELECTED_COMPETENCIES_SUCCESS';
export const SAVE_SELECTED_COMPETENCIES_FAILED =
  'SAVE_SELECTED_COMPETENCIES_FAILED';
export const ONBOARD_EMPLOYEE_SKILLS_NOTIFICATION_ARRIVED =
  'ONBOARD_EMPLOYEE_SKILLS_NOTIFICATION_ARRIVED';
export const ONBOARD_EMPLOYEE_ROLES_STARTED = 'ONBOARD_EMPLOYEE_ROLES_STARTED';
export const ONBOARD_EMPLOYEE_ROLES_SUCCESS = 'ONBOARD_EMPLOYEE_ROLES_SUCCESS';
export const ONBOARD_EMPLOYEE_ROLES_FAILED = 'ONBOARD_EMPLOYEE_ROLES_FAILED';
export const ONBOARD_EMPLOYEE_ROLES_NOTIFICATION_ARRIVED =
  'ONBOARD_EMPLOYEE_ROLES_NOTIFICATION_ARRIVED';
export const ONBOARD_EMPLOYEE_OPEN_TO_WORK_STARTED =
  'ONBOARD_EMPLOYEE_OPEN_TO_WORK_STARTED';
export const ONBOARD_EMPLOYEE_OPEN_TO_WORK_SUCCESS =
  'ONBOARD_EMPLOYEE_OPEN_TO_WORK_SUCCESS';
export const ONBOARD_EMPLOYEE_OPEN_TO_WORK_FAILED =
  'ONBOARD_EMPLOYEE_OPEN_TO_WORK_FAILED';
export const ONBOARD_EMPLOYEE_OPEN_TO_WORK_NOTIFICATION_ARRIVED =
  'ONBOARD_EMPLOYEE_OPEN_TO_WORK_NOTIFICATION_ARRIVED';
export const GET_ALL_COMPETENCIES_STARTED = 'GET_ALL_COMPETENCIES_STARTED';
export const GET_ALL_COMPETENCIES_SUCCESS = 'GET_ALL_COMPETENCIES_SUCCESS';
export const TUAY_SKIP_UPDATED = 'TUAY_SKIP_UPDATED';
